import { ModalStatus } from "client/common/types";

/** Matches docs SupportTileEnum */
export enum SupportTileEnum {
  ClinicPhone = "CLINIC_PHONE",
  ClinicSms = "CLINIC_SMS",
  ClinicEmail = "CLINIC_EMAIL",
  ClinicHours = "CLINIC_HOURS",
  VetcovePhone = "VETCOVE_PHONE",
  VetcoveSms = "VETCOVE_SMS",
  VetcoveEmail = "VETCOVE_EMAIL",
  Chat = "CHAT",
  OrderStatus = "ORDER_STATUS",
}

/** matches docs ClientSupportSectionTileListSerializer */
export interface IListSupportSectionTile {
  id: number;
  kind: SupportTileEnum;
}

/** matches docs ClientSupportSectionItemListSerializer */
export interface IListSupportSectionItem {
  id: number;
  title: string;
  body: string; // markdown
  tiles: IListSupportSectionTile[];
}

/** matches docs ClientSupportSectionListSerializer */
export interface IListSupportSection {
  id: number;
  title: string;
  items: IListSupportSectionItem[];
}

/** matches docs ClientSupportItemSectionListSerializer */
export interface IListSupportItemSection {
  id: number;
  title: string;
}

/** matches docs ClientSupportItemListSerializer  */
export interface IListSupportItem {
  id: number;
  title: string;
  support_section: IListSupportItemSection;
  body: string;
}

export interface ListSupportItemsSearch {
  q: string;
}

export type HelpCenterSearch = {
  orderStatusModalIsVisible?: ModalStatus;
  orderStatusInitialOrderNumber?: string;
};

export type SetModalVisibility = (param: keyof HelpCenterSearch, visibility: ModalStatus) => void;
